"use client";

import { useEffect, useState } from 'react';
import Link from 'next/link';

export default function Custom404() {
    const [isAnimating, setIsAnimating] = useState(true);
    
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsAnimating(false);
        }, 3000);
        
        return () => clearTimeout(timer);
    }, []);
    
    return (
        <div className="flex flex-col items-center justify-center h-[calc(100vh)] w-full bg-gradient-to-b from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
            <div className="max-w-2xl px-6 py-16 text-center">
                <div className={`mb-8 transition-all duration-1000 ${isAnimating ? 'scale-150 opacity-100' : 'scale-100 opacity-80'}`}>
                    <h1 className="text-9xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600">404</h1>
                </div>
                
                <h2 className="mb-4 text-3xl font-bold text-gray-800 dark:text-gray-200">Oops! Page not found</h2>
                
                <p className="mb-8 text-lg text-gray-600 dark:text-gray-400">
                    The page you&apos;re looking for doesn&apos;t exist or has been moved.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link href="/" className="px-6 py-3 text-white font-medium bg-gradient-to-r from-primary to-primary/80 rounded-lg shadow-md hover:from-primary/90 hover:to-primary/90 transition-all duration-300 transform hover:-translate-y-1">
                        Go Home
                    </Link>
                    <Link href="javascript:history.back()" className="px-6 py-3 text-gray-700 dark:text-gray-200 font-medium bg-gray-200 dark:bg-gray-700 rounded-lg shadow-md hover:bg-gray-300 dark:hover:bg-gray-600 transition-all duration-300 transform hover:-translate-y-1">
                        Go Back
                    </Link>
                </div>
            </div>
        </div>
    );
}